import React from "react";
import RedirectingPage from "./RedirectingPage";

const Tutorias = () => (
  <RedirectingPage url="https://app.copywriteeducacion.com/public/forms/tutorship" />
);

export default Tutorias;
